import PropTypes       from 'prop-types';
import React           from 'react';
import FeedPost        from './FeedPost';
import Modal           from './../Modal';
import Flux            from '../../flux/Flux';
import { postClipType,
         isRecommended,
         postType }    from './FeedHelper';
import {removePreventScrolling} from '../../utils/CommonUtils';

const OVERLAY_CLASS = "feed-overlay";
class FeedPostWrapper extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOverlay:   false,
      overlayType: '',
    };

    this.handleKeyDown               = this.handleKeyDown.bind(this);
    this.onOverlayChange             = this.onOverlayChange.bind(this);
    this.onCloseMobileAnimationModal = this.onCloseMobileAnimationModal.bind(this);
    this.onOverlayClick              = this.onOverlayClick.bind(this);
  }

  componentDidMount() {
    this.state.isOverlay && document.addEventListener('keydown', this.handleKeyDown);
    Flux.Feed.addOverlayChangeListener(this.onOverlayChange);
  }

  componentWillUnmount() {
    if (this.state.isOverlay) {
      removePreventScrolling();
    }
    this.state.isOverlay && document.removeEventListener('keydown', this.handleKeyDown);
    Flux.Feed.removeOverlayChangeListener(this.onOverlayChange);
  }


  onOverlayChange(selectedPostId, overlayType, imageId) {
    if (selectedPostId === this.props.id) {
      if (!this.state.isOverlay) {
        this.setState({overlayType, imageId: imageId, isOverlay: true});
        document.addEventListener('keydown', this.handleKeyDown);
      } else {
        this.setState({overlayType: '', imageId: '', isOverlay: false}, () => {
          document.removeEventListener('keydown', this.handleKeyDown);
        });
      }
    }
  }

  handleKeyDown(e) {
		switch(e.which) {
			case 27: //ESC
				Flux.Feed.toggleOverlay(this.props.id);
				break;
		}
	}

  onCloseMobileAnimationModal() {
    setTimeout(() => {
      Flux.Feed.toggleOverlay(this.props.id);
    }, 50);
  }

  onOverlayClick(e) {
    if (e.target.classList.contains(OVERLAY_CLASS)) {
      Flux.Feed.toggleOverlay(this.props.id);
    }
  }
  render() {
    if (this.props.tippingGoal !== null && this.props.tippingGoal.goalCoins === null || this.props.paidContent && (this.props.priceCoins === null || this.props.priceCoins === undefined)) {
        return null;
    }

    const isComment = this.state.overlayType === Flux.Constants.Feed.OverlayTypes.COMMENTS;
    const isTablet  = Flux.Browser.isTablet();
    const isLandscape = isTablet && Flux.Browser.isLandscape();
    if (this.props.isMobile) {
      return <div>
                {this.state.isOverlay && isComment &&
                  <Modal modalClassName="feed-modal" hideCloseButton={false} animation={{useAnimation: true, fromRight: isComment}} beforeAnimationClose={this.onCloseMobileAnimationModal}>
                    <div className={OVERLAY_CLASS}>
                        <FeedPost {...this.props} overlayType={this.state.overlayType} isOverlay={true} isRecommended={isRecommended(this.props.type)} imageId={this.state.imageId} initFavorite={this.props.initFavorite}/>
                    </div>
                </Modal>
                }
                {<div className={this.state.isOverlay && !isComment ? OVERLAY_CLASS + " feed-overlay--fixed" : ""}>
                  <FeedPost {...this.props} overlayType={this.state.overlayType} isOverlay={this.state.isOverlay  && !isComment} isRecommended={isRecommended(this.props.type)} imageId={this.state.imageId} initFavorite={this.props.initFavorite} isMain={this.state.isOverlay} />
                </div>}
      </div>;
    }
    return (
      <div className={this.state.isOverlay ? OVERLAY_CLASS + " feed-overlay--fixed" : ""} onClick={this.onOverlayClick}>
          {this.state.isOverlay && ((!isTablet || isTablet && isComment) || isLandscape) && <i className='icon -icon-close-line modal__btn-close' tabIndex={0}
                                                                                               onKeyDown={(e) => e.key === 'Enter' && Flux.Feed.toggleOverlay(this.props.id)} onClick={() => {Flux.Feed.toggleOverlay(this.props.id);}}></i>}
          {this.state.isOverlay && isTablet && !isLandscape && isComment && <FeedPost {...this.props} overlayType={this.state.overlayType} isOverlay={this.state.isOverlay} isTablet={true} isRecommended={isRecommended(this.props.type)} imageId={this.state.imageId} initFavorite={this.props.initFavorite} />}
            <FeedPost {...this.props}
              isOverlay={this.state.isOverlay}
              overlayType={Flux.Constants.Feed.OverlayTypes.ALL}
              isTablet={isTablet}
              isRecommended={isRecommended(this.props.type)}
              imageId={this.state.imageId}
              initFavorite={this.props.initFavorite}
              isTabletOverlayComment={this.state.isOverlay && (isTablet) && isComment}
              isLandscape={isLandscape} />
        </div>
    );
  }
}

FeedPostWrapper.propTypes = {
    actorName:      PropTypes.string,
    actorImageUrl:  PropTypes.string,
    feedType:       PropTypes.string,
    isMobile:       PropTypes.bool,
    initFavorite:   PropTypes.bool,
    imageId:        PropTypes.string,
    clip:           PropTypes.shape(postClipType),
    ...postType
};

FeedPostWrapper.defaultProps = {
    isOverlay:  false,

};


export default FeedPostWrapper;
